import { SocialPostTaggedUser } from "@rewards-web/shared/graphql-types";

export function noTaggedUsersToDisplay(
  taggedUsers: SocialPostTaggedUser[]
): boolean {
  return taggedUsers.filter((user) => user.firstNameLastInitial).length === 0;
}
